exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rating[data-v-42691b92]{width:100%;max-width:600px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;flex-direction:column;align-items:center}.rating__name img[data-v-42691b92]{width:40px;border-radius:8px;margin-right:10px}.rating__left[data-v-42691b92]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;align-items:center}.rating__items[data-v-42691b92]{width:100%}.setup__item div[data-v-42691b92]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;justify-content:center}.setup__item label[data-v-42691b92]{margin-bottom:5px}", ""]);

// exports
